module.exports = __webpack_public_path__ + "img/hand-wave.b96ecd31.svg";